import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import "../../../../assets/styles/_modal.scss";

interface ConfirmModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    vornameEmpty: boolean;
    nachnameEmpty: boolean;
    emailEmpty: boolean;
    phoneNumberEmpty: boolean;
    zipCodeEmpty: boolean;
    regionEmpty: boolean;
    productEmpty: boolean;
}

/**
 * ConfirmModal use it to show a confirmation modal if something is missing.
 */
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    onCancel,
    onConfirm,
    vornameEmpty,
    nachnameEmpty,
    emailEmpty,
    phoneNumberEmpty,
    zipCodeEmpty,
    regionEmpty,
    productEmpty
}) => {
    const missingFields = [
        { empty: vornameEmpty, label: "Vorname" },
        { empty: nachnameEmpty, label: "Nachname" },
        { empty: emailEmpty, label: "E-Mail-Adresse" },
        { empty: phoneNumberEmpty, label: "Telefonnummer" },
        { empty: zipCodeEmpty, label: "Postleitzahl" },
        { empty: regionEmpty, label: "Ort" },
        { empty: productEmpty, label: "Bedarf" }
    ]
        .filter((field) => field.empty)
        .map((field) => field.label);
    return (
        <Modal
            className="create-request-modal"
            open={open}
            onClose={onCancel}
            aria-labelledby="create-request"
            aria-describedby="create-request"
        >
            <div className="create-request-body">
                <div
                    className="icon icon-close"
                    role="button"
                    onClick={onCancel}
                ></div>
                <p className="text-black mt-20">
                    <strong>
                        Wir empfehlen die folgenden Felder ebenfalls
                        auszufüllen:
                    </strong>
                </p>
                <ol className="list-check-error">
                    {missingFields.map((field, index) => (
                        <li key={index}>{field}</li>
                    ))}
                </ol>
                <p className="text-black mt-20">
                    <strong>
                        Möchten Sie den Klienten wirklich ohne diese Angaben
                        speichern?
                    </strong>
                </p>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    className="mt-20"
                >
                    <button
                        type="button"
                        className="btn btn-info btn-medium-small mr-15"
                        onClick={onCancel}
                    >
                        Abbrechen
                    </button>
                    <button
                        type="button"
                        className="btn btn-medium-small"
                        onClick={onConfirm}
                    >
                        Trotzdem speichern
                    </button>
                </Box>
            </div>
        </Modal>
    );
};
